import { RichText } from "@components/cms/rich-text-renderer/RichText";
import { CheckboxField } from "@components/ui/form/CheckboxField/CheckboxField";
import type { Document } from "@contentful/rich-text-types";
import type { ContactDetailsInitialValues } from "@lib/utils/checkoutHelper";
import { Text } from "@ecco/ui/text";
import { Box } from "@ecco/ui/box";
import { Flex } from "@ecco/ui/flex";
import { useFormContext } from "react-hook-form";

interface NewsletterConsentFieldProps {
    newsletterConsentTitle: string;
    newsletterConsentPolicy: Document;
}

export default function NewsletterConsentField({
    newsletterConsentTitle,
    newsletterConsentPolicy,
}: NewsletterConsentFieldProps) {
    const { register } = useFormContext<ContactDetailsInitialValues>();

    return (
        <Box my="4">
            <Flex alignItems="start" gap="1">
                <CheckboxField
                    {...register("isSubscribed")}
                    name="isSubscribed"
                    label={<Text fontWeight={"bold"}>{newsletterConsentTitle}</Text>}
                >
                    <Box mt={2} display={"block"}>
                        <RichText data={newsletterConsentPolicy} />
                    </Box>
                </CheckboxField>
            </Flex>
        </Box>
    );
}
